// ARTE theme — minimal client JS
document.addEventListener('click', (e) => {
  const a = e.target.closest('a[href^="#"]');
  if (!a) return;
  const id = a.getAttribute('href').slice(1);
  if (!id) return;
  const el = document.getElementById(id);
  if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
});


// Mobile hamburger menu toggle
(function () {
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.getElementById('MobileNav');
  if (!toggle || !nav) return;

  function setOpen(open) {
    document.body.classList.toggle('nav-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }

  toggle.addEventListener('click', function () {
    setOpen(!document.body.classList.contains('nav-open'));
  });

  // Close when clicking the dimmed backdrop (outside the panel)
  nav.addEventListener('click', function (e) {
    if (e.target === nav) setOpen(false);
  });

  // Close when a menu link is chosen
  nav.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', function () { setOpen(false); });
  });

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setOpen(false);
  });

  // Reset when resizing up to desktop
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 860) setOpen(false);
  });
})();
// Hero slideshow (autoplay + swipe/click carousel)
(function () {
  const shows = document.querySelectorAll('[data-hs-slideshow]');
  shows.forEach(function (show) {
    const slides = Array.from(show.querySelectorAll('[data-hs-slide]'));
    const dots = Array.from(show.querySelectorAll('[data-hs-dot]'));
    if (slides.length < 2) return;

    const autorotate = show.getAttribute('data-autorotate') === 'true';
    const interval = parseInt(show.getAttribute('data-interval'), 10) || 5000;
    let index = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (index < 0) index = 0;
    let timer = null;

    function goTo(i) {
      slides[index].classList.remove('is-active');
      if (dots[index]) dots[index].classList.remove('is-active');
      index = (i + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      if (dots[index]) dots[index].classList.add('is-active');
    }

    function next() { goTo(index + 1); }

    function play() {
      if (!autorotate) return;
      stop();
      timer = setInterval(next, interval);
    }

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function restartAfterInteraction() {
      stop();
      play();
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        restartAfterInteraction();
      });
    });

    // Swipe support
    let startX = 0;
    show.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      stop();
    }, { passive: true });

    show.addEventListener('touchend', function (e) {
      const diff = e.changedTouches[0].clientX - startX;
      if (Math.abs(diff) > 40) {
        diff < 0 ? next() : goTo(index - 1);
      }
      play();
    });

    play();
  });
})();